import lightbox from 'lightbox2';

$( document ).on('turbolinks:load', function() {
  lightbox.init();
});